import { ThreatAssessment } from '../../dossiers-and-panels/threat-assessments/threat-assessment.model';
import { wrapRequest } from '../base';

export const getThreatAssessment = (
  threatAssessmentId: string | number
): Promise<ThreatAssessment> =>
  wrapRequest(
    'get',
    'geonius',
    `/risk-intelligence/threat-assessments/${threatAssessmentId}`
  );
